'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Array sort comparator to sort an array by provided field name alphanumerically.
 * Supports pulling nested properties using _.get or .getIn if Immutable.
 * E.g. a list of volumes such as 'v1', 'v3', 'v10', 'v2' will be sorted as
 * 'v1', 'v2', 'v3', 'v10' rather than 'v1', 'v10', 'v2', 'v3'.
 *
 * Sorting by key solution adapted from http://stackoverflow.com/questions/979256/sorting-an-array-of-javascript-objects/979325#979325
 * Alphanumeric sorting adapted from https://github.com/yobacca/node-natural-sort, which included sort direction and used ES2015
 * eslint rules ignored in several places to maintain code without changes
 *
 * @param  {string} fieldName
 * @param  {string} order - 'asc' or 'desc'
 * @param  {boolean} caseSensitive
 * @return {function}
 */
function naturalSortBy(fieldName, order, caseSensitive) {
  var key = function key(item) {
    if (fieldName) {
      var normalizedField = _lodash2.default.split(fieldName, '.');
      return _immutable2.default.Map.isMap(item) ? item.getIn(normalizedField) : _lodash2.default.get(item, normalizedField);
    }

    return item;
  };

  return function (valueA, valueB) {
    var re = /(^([+\-]?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?(?=\D|\s|$))|^0x[\da-fA-F]+$|\d+)/g; // eslint-disable-line
    var sre = /^\s+|\s+$/g; // trim pre-post whitespace
    var snre = /\s+/g; // normalize all whitespace to single ' ' character
    var dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/; // eslint-disable-line
    var hre = /^0x[0-9a-f]+$/i;
    var ore = /^0/;
    var i = function i(s) {
      return (!caseSensitive && ('' + s).toLowerCase() || '' + s).replace(sre, '');
    }; // eslint-disable-line
    // convert all to strings strip whitespace
    var x = i(
    // switch parameter for descending order
    order === 'desc' ? key(valueB) : key(valueA));
    var y = i(
    // switch parameter for descending order
    order === 'desc' ? key(valueA) : key(valueB));
    // chunk/tokenize
    var xN = x.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0');
    var yN = y.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0');
    // numeric, hex or date detection
    var xD = parseInt(x.match(hre), 16) || xN.length !== 1 && Date.parse(x);
    var yD = parseInt(y.match(hre), 16) || xD && y.match(dre) && Date.parse(y) || null; // eslint-disable-line
    // normalize spaces; find floats not starting with '0',
    // string or 0, if not defined (Clint Priest)
    var normChunk = function normChunk(s, l) {
      return (!s.match(ore) || l === 1) && parseFloat(s) || s.replace(snre, ' ').replace(sre, '') || 0 // eslint-disable-line
      ;
    };
    var oFxNcL = void 0;
    var oFyNcL = void 0;
    // first try and sort Hex codes or Dates
    if (yD) {
      if (xD < yD) {
        return -1;
      } else if (xD > yD) {
        return 1;
      }
    }
    // natural sorting through split numeric strings and default strings
    for (var cLoc = 0, xNl = xN.length, yNl = yN.length, numS = Math.max(xNl, yNl); cLoc < numS; cLoc++ // eslint-disable-line
    ) {
      oFxNcL = normChunk(xN[cLoc] || '', xNl);
      oFyNcL = normChunk(yN[cLoc] || '', yNl);
      // handle numeric vs string comparison - number < string - (Kyle Adams)
      if (isNaN(oFxNcL) !== isNaN(oFyNcL)) {
        return isNaN(oFxNcL) ? 1 : -1;
      }
      // if unicode use locale comparison
      if (/[^\x00-\x80]/.test(oFxNcL + oFyNcL) && oFxNcL.localeCompare) {
        // eslint-disable-line
        var comp = oFxNcL.localeCompare(oFyNcL);
        return comp / Math.abs(comp);
      }
      if (oFxNcL < oFyNcL) {
        return -1;
      } else if (oFxNcL > oFyNcL) {
        return 1;
      }
    }
    return 0;
  };
}

exports.default = naturalSortBy;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/natural-sort-by/lib/services/naturalSortBy.service.js
// module id = 1432
// module chunks = 1